const mutations = {
  getCaptchas: (state, captcha) => {
    state.captcha = captcha;
  },
  getCaptcha: (state, captcha_id) => {
    state.captcha_id = captcha_id;
  },
  postCaptcha: (state, new_captcha) => {
    state.captcha.push(new_captcha);
  },
  putCaptcha: (state, payload) => {
    state.captcha = state.captcha.map((captcha) => {
      if (captcha.captcha_id === payload.id) {
        return Object.assign({}, captcha, payload.captchaData);
      }
      return captcha;
    });
  },
  delCaptcha(state, id) {
    const index = state.captcha.findIndex(captcha => captcha.captcha_id == id);
    state.captcha.splice(index, 1);
  },
};

export default mutations;
